import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genRoundedArrow } from './roundedArrow';
export var MAX_VERTICAL_CONTENT_RADIUS = 8;
export function getArrowOffsetToken(options) {
  var contentRadius = options.contentRadius,
      limitVerticalRadius = options.limitVerticalRadius;
  var arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  var arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical: arrowOffsetVertical
  };
}

function isInject(valid, code) {
  if (!valid) {
    return {};
  }

  return code;
}

export default function getArrowStyle(token, colorBg, options) {
  var _isInject, _isInject2, _isInject3, _isInject4;

  var componentCls = token.componentCls,
      boxShadowPopoverArrow = token.boxShadowPopoverArrow,
      arrowOffsetVertical = token.arrowOffsetVertical,
      arrowOffsetHorizontal = token.arrowOffsetHorizontal;

  var _ref = options || {},
      _ref$arrowDistance = _ref.arrowDistance,
      arrowDistance = _ref$arrowDistance === void 0 ? 0 : _ref$arrowDistance,
      _ref$arrowPlacement = _ref.arrowPlacement,
      arrowPlacement = _ref$arrowPlacement === void 0 ? {
    left: true,
    right: true,
    top: true,
    bottom: true
  } : _ref$arrowPlacement;

  return _defineProperty({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(_defineProperty({}, "".concat(componentCls, "-arrow"), [Object.assign(Object.assign({
    position: 'absolute',
    zIndex: 1,
    display: 'block'
  }, genRoundedArrow(token, colorBg, boxShadowPopoverArrow)), {
    '&:before': {
      background: colorBg
    }
  })]), isInject(!!arrowPlacement.top, (_isInject = {}, _defineProperty(_isInject, ["&-placement-top > ".concat(componentCls, "-arrow"), "&-placement-topLeft > ".concat(componentCls, "-arrow"), "&-placement-topRight > ".concat(componentCls, "-arrow")].join(','), {
    bottom: arrowDistance,
    transform: 'translateY(100%) rotate(180deg)'
  }), _defineProperty(_isInject, "&-placement-top > ".concat(componentCls, "-arrow"), {
    left: {
      _skip_check_: true,
      value: '50%'
    },
    transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
  }), _defineProperty(_isInject, "&-placement-topLeft > ".concat(componentCls, "-arrow"), {
    left: {
      _skip_check_: true,
      value: arrowOffsetHorizontal
    }
  }), _defineProperty(_isInject, "&-placement-topRight > ".concat(componentCls, "-arrow"), {
    right: {
      _skip_check_: true,
      value: arrowOffsetHorizontal
    }
  }), _isInject))), isInject(!!arrowPlacement.bottom, (_isInject2 = {}, _defineProperty(_isInject2, ["&-placement-bottom > ".concat(componentCls, "-arrow"), "&-placement-bottomLeft > ".concat(componentCls, "-arrow"), "&-placement-bottomRight > ".concat(componentCls, "-arrow")].join(','), {
    top: arrowDistance,
    transform: "translateY(-100%)"
  }), _defineProperty(_isInject2, "&-placement-bottom > ".concat(componentCls, "-arrow"), {
    left: {
      _skip_check_: true,
      value: '50%'
    },
    transform: "translateX(-50%) translateY(-100%)"
  }), _defineProperty(_isInject2, "&-placement-bottomLeft > ".concat(componentCls, "-arrow"), {
    left: {
      _skip_check_: true,
      value: arrowOffsetHorizontal
    }
  }), _defineProperty(_isInject2, "&-placement-bottomRight > ".concat(componentCls, "-arrow"), {
    right: {
      _skip_check_: true,
      value: arrowOffsetHorizontal
    }
  }), _isInject2))), isInject(!!arrowPlacement.left, (_isInject3 = {}, _defineProperty(_isInject3, ["&-placement-left > ".concat(componentCls, "-arrow"), "&-placement-leftTop > ".concat(componentCls, "-arrow"), "&-placement-leftBottom > ".concat(componentCls, "-arrow")].join(','), {
    right: {
      _skip_check_: true,
      value: arrowDistance
    },
    transform: 'translateX(100%) rotate(90deg)'
  }), _defineProperty(_isInject3, "&-placement-left > ".concat(componentCls, "-arrow"), {
    top: {
      _skip_check_: true,
      value: '50%'
    },
    transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
  }), _defineProperty(_isInject3, "&-placement-leftTop > ".concat(componentCls, "-arrow"), {
    top: arrowOffsetVertical
  }), _defineProperty(_isInject3, "&-placement-leftBottom > ".concat(componentCls, "-arrow"), {
    bottom: arrowOffsetVertical
  }), _isInject3))), isInject(!!arrowPlacement.right, (_isInject4 = {}, _defineProperty(_isInject4, ["&-placement-right > ".concat(componentCls, "-arrow"), "&-placement-rightTop > ".concat(componentCls, "-arrow"), "&-placement-rightBottom > ".concat(componentCls, "-arrow")].join(','), {
    left: {
      _skip_check_: true,
      value: arrowDistance
    },
    transform: 'translateX(-100%) rotate(-90deg)'
  }), _defineProperty(_isInject4, "&-placement-right > ".concat(componentCls, "-arrow"), {
    top: {
      _skip_check_: true,
      value: '50%'
    },
    transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
  }), _defineProperty(_isInject4, "&-placement-rightTop > ".concat(componentCls, "-arrow"), {
    top: arrowOffsetVertical
  }), _defineProperty(_isInject4, "&-placement-rightBottom > ".concat(componentCls, "-arrow"), {
    bottom: arrowOffsetVertical
  }), _isInject4))));
}